import React, {useState} from 'react'
import {Container, Image, Nav, Navbar, NavDropdown} from 'react-bootstrap'
import {localise} from '../../services/LocalizationServices'
import {v4} from 'uuid'
import {
  ABOUT_ME_URL,
  ROOT_URL,
  SERVICES_URL,
  CONTACT_URL,
  TESTIMONIALS_URL,
} from '../../constants/urls'
import {HAMBURGER_ICON, LOGO} from '../../constants/pngs'
import Separator from '../separator/Separator'
import {Link} from 'react-router-dom'

const TopNav = () => {
  const [expanded, setExpanded] = useState(false)

  const links = [
    {
      to: ROOT_URL,
      translationKey: 'nav.home',
      children: [],
      activeViews: ['home'],
    },
    {
      to: ABOUT_ME_URL,
      translationKey: 'nav.aboutMe',
      children: [],
      activeViews: ['about-me'],
    },
    {
      to: SERVICES_URL,
      translationKey: 'nav.services',
      children: [],
      activeViews: ['services'],
    },
    {
      to: TESTIMONIALS_URL,
      translationKey: 'nav.testimonials',
      children: [],
      activeViews: ['testimonials'],
    },
    {
      to: CONTACT_URL,
      translationKey: 'nav.contactMe',
      children: [],
      activeViews: ['contact-me'],
    },
  ]

  const isActiveLink = views => {
    const pathname = window.location.href

    const parsedUrl = pathname.toLowerCase().replace(/\s/g, '')
    return views.some(view => parsedUrl.includes(view))
  }

  const constructMenuItem = item => {
    if (item.children.length === 0) {
      return <Nav.Link key={v4()} as={Link} to={item.to} onClick={() => setExpanded(false)}>
        <div
          className={`custom-tab-item ${isActiveLink(item?.activeViews || []) ? 'active' : ''}`}>
          {localise(item?.translationKey)}
        </div>
      </Nav.Link>
    } else {
      return <NavDropdown
        key={v4()}
        title={localise(item.translationKey)}
        className={`custom-dropdown ${isActiveLink(item.children.map(item => item.to)) ? 'active' : 'inactive'}`}>
        {
          item.children.map(child => {
            return <NavDropdown.Item
              className={`custom-dropdown-item ${isActiveLink([child.to]) ? 'active' : 'inactive'}`}
              key={v4()}
              as={Link}
              to={child.to}
              onClick={() => setExpanded(false)}>
              {localise(child.translationKey)}
            </NavDropdown.Item>
          })
        }
      </NavDropdown>
    }
  }

  return (
    <Navbar className='top-nav-style m-auto' variant='light' expand='lg' fixed='top' expanded={expanded}>
      <Container className='justify-content-center'>
        <Navbar.Brand href={ROOT_URL}>
          <div className='nav-logo-div'>
            <Image src={LOGO} height={40} alt={localise('alt.companyLogo')} />
            <div className='ms-2 nav-logo-text'>THE HYPNOTHERAPY PRACTICE</div>
          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls='basic-navbar-nav'
          onClick={() => setExpanded(expanded ? false : 'expanded')}>
          <Image src={HAMBURGER_ICON} height={24} width={24}/>
        </Navbar.Toggle>
        <Navbar.Collapse id='basic-navbar-nav'>
          <Separator className='my-2'/>
          <Nav className='ms-auto mx-2'>
            {links.map(item => constructMenuItem(item))}
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  )
}

export default TopNav